import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Filter } from 'src/app/shared/models/filter.model';
import { Lookup } from 'src/app/shared/models/admin-models/lookup.model';
import { Observable } from 'rxjs';
import { ClientStatusService } from 'src/app/shared/services/admin-services/client-status.service';

@Component({
  selector: 'app-client-statuses',
  templateUrl: './client-statuses.component.html',
  styleUrls: ['./client-statuses.component.sass']
})
export class ClientStatusesComponent implements OnInit {
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faTrashAlt = faTrashAlt;

  addOrEditBool: Boolean = true;
  filter: Filter = new Filter({ Top: null, Page: null, Filter: {}, Sort: {} })
  lookupId: Number;
  lookupArray: Observable<Lookup[]>;

  filterForm = new FormGroup({
    name: new FormControl('', [])
  })

  lookupForm = new FormGroup({
    name: new FormControl('', [Validators.required])
  })

  constructor(private modalService: NgbModal, private clinetStatusService: ClientStatusService) { }

  ngOnInit() {
    this.getAll()
  }

  getAll() {
    this.filter.data.Filter = {};
    if (this.filterForm.value.name)
      this.filter.data.Filter.Name = this.filterForm.value.name

    this.lookupArray = this.clinetStatusService.gridView();
  }

  openAddLookupModal(modal) {
    this.lookupForm.reset();
    this.addOrEditBool = true;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  addLookup() {
    let lookup = new Lookup({ Name: this.lookupForm.value.name })
    this.clinetStatusService.createClientStatus(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openEditLookupModal(modal, id) {
    this.addOrEditBool = false;
    this.clinetStatusService.getOne(id)
      .then(
        (x: { id: Number, name: String }) => {
          this.lookupId = id;
          this.lookupForm.get('name').setValue(x.name);
          this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
        }
      )
  }
  editLookup() {
    let lookup = new Lookup({ Id: this.lookupId, Name: this.lookupForm.value.name })
    this.clinetStatusService.editClientStatus(lookup)
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  openDeleteLookupModal(modal, id) {
    this.lookupId = id;
    this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
  }
  deleteLookup() {
    this.clinetStatusService.deleteClientStatus([this.lookupId])
      .then(
        x => {
          this.getAll();
          this.modalService.dismissAll();
        }
      )
  }

  clearFilters() {
    this.filterForm.reset({ name: '' })
    this.getAll();
  }

}
